export default __webpack_public_path__ + "static/media/lobby_first_image.c5634599.jpg";